SupportTicketSuccessView = require('./ticket_success_view')

class SupportEmailSuccessView extends  SupportTicketSuccessView

  toHash: ->
    hash = SupportTicketSuccessView::toHash.call(this)
    hash.showDefaultThankYouMsg = false
    hash.showEmailThankYouMsg =  true
    hash.showNeedHelpLink = true
    hash

  shouldShowFooter: () ->
   false

  getGreetingText: () ->
    if @isRefundEligible()
      I18n.translate('js.modules.support.request_submitted_successfully')
    else
      I18n.translate('js.modules.support.v2.thanks_email')

module.exports = SupportEmailSuccessView
